import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";
import type AddPlanDto from "./dto/add-plan.dto";

export const PlanEffectActions = {
  addPlan: `${Entities.Plan}_addPlan`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.Plan,
  initSchema,
  aliasName: DIContainerKeys.PlanService,
})
export class PlanService extends HttpService {
  @loader(Loaders.AddPlanLoader)
  @flagger(Flaggers.AddPlanModalFlagger)
  @action(DIContainerKeys.PlanService)
  public *addPlan(dto: AddPlanDto): Generator<any, void, any> {
    
  }
}

